import classNames from 'classnames/bind';
import styles from './OmossValues.module.scss';

let cx = classNames.bind(styles);

export default function OmossValues({ data }) {
  if (!data) return null;

  return (
    <section className={cx('valuesSection')}>
      <div className={cx('container')}>
        <div className={cx('headerContent')}>
          <h2>{data.header}</h2>
          {data.subHeader && (
            <p>{data.subHeader}</p>
          )}
        </div>
        {data.catchphrases && (
          <div className={cx('valuesGrid')}>
            {data.catchphrases.map((item, index) => (
              <div key={index} className={cx('valueCard')}>
                <div className={cx('cardContent')}>
                  <span className={cx('cardNumber')}>{index + 1}</span>
                  <div dangerouslySetInnerHTML={{ __html: item.text }} />
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
} 